import React, { useRef, useState } from "react";
import Button from "../../../../Components/UI/Button/Button";
import Card from "../../../../Components/UI/Card/Card";
// import Helper from "../../../lib/Helper";

import { Camera, CameraType } from 'react-camera-pro';

import styles from './PhotoReader.module.css';

const isMobile = () =>
  typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;

const readFile = (file, onLoad) => {
  const reader = new FileReader();
  reader.onload = (ev) => onLoad(ev.target.result);
  reader.readAsDataURL(file);
};

const NativePhotoReader = (props) => {
  const cameraInputRef = useRef(null);
  const libraryInputRef = useRef(null);
  const [facing, setFacing] = useState('environment');

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) readFile(file, props.onTrigger);
  };

  const toggleFacing = () =>
    setFacing(f => f === 'environment' ? 'user' : 'environment');

  return (
    <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <input ref={cameraInputRef} type="file" accept="image/*" capture={facing}
             style={{ display: 'none' }} onChange={onFileChange} />
      <input ref={libraryInputRef} type="file" accept="image/*"
             style={{ display: 'none' }} onChange={onFileChange} />
      <Button onClick={() => cameraInputRef.current?.click()}><i className="fas fa-camera" /> Foto aufnehmen</Button>
      <Button style={{ margin: '10px auto' } } onClick={toggleFacing}>
        <i className="fas fa-camera-rotate" /> {facing === 'environment' ? 'Frontkamera' : 'Rückkamera'}
      </Button>
      <Button onClick={() => libraryInputRef.current?.click()}><i className="fas fa-images" /> Aus Fotobibliothek</Button>
      <Button onClick={props.onCancel}><i className="fas fa-xmark" /> Abbrechen</Button>
    </div>
  );
};

const DesktopPhotoReader = (props) => {
  const [numberOfCameras, setNumberOfCameras] = useState(0);
  const camera = useRef(null);
  const fileInputRef = useRef(null);

  const onTrigger = () => {
    if (camera.current) {
      const photo = camera.current.takePhoto();
      props.onTrigger(photo);
    }
  };

  const onCameraSelect = () => {
    if (camera.current) {
      camera.current.switchCamera();
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) readFile(file, props.onTrigger);
  };

  return (
    <>
      <input ref={fileInputRef} type="file" accept="image/*"
             style={{ display: 'none' }} onChange={onFileChange} />
      <div className={styles.wrapper}>
        <Camera ref={camera}
                aspectRatio="cover"
                numberOfCamerasCallback={setNumberOfCameras}
                facingMode="environment"
        />
        <div className={styles.control}>
          <button className={styles.icon_button}
                  onClick={props.onCancel}
                  title="Abbrechen">
            <i className="fas fa-xmark" />
          </button>
          <button className={`${styles.icon_button} ${styles.take_photo_button}`}
                  onClick={onTrigger}
                  title="Foto aufnehmen">
            <i className="fas fa-camera" />
          </button>
          <button className={styles.icon_button}
                  disabled={numberOfCameras <= 1}
                  onClick={onCameraSelect}
                  title="Kamera wechseln">
            <i className="fas fa-camera-rotate" />
          </button>
          <button className={styles.icon_button}
                  onClick={() => fileInputRef.current?.click()}
                  title="Datei laden">
            <i className="fas fa-folder-open" />
          </button>
        </div>
      </div>
    </>
  );
};

const PhotoReader = (props) => {
  return isMobile()
    ? <NativePhotoReader {...props} />
    : <DesktopPhotoReader {...props} />;
};

export default PhotoReader;
